module.exports = __webpack_public_path__ + "activity4.978fa244.png";